/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-28 12:07:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 15:36:26
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/Components/Header/index.tsx
 */
import NoPermission from '@/src/components/NoPermission';
import React from 'react';
import _Header from 'src/components/Layouts/Header';
import { useI18n } from 'src/hooks/useRouterChange';
import Element from 'src/layout/EditorPageLayout/Element/Elements';
import { i18nGet } from 'src/tools/tools';

// import {
//   // isEditing,
//   // onAddNewCategory,
//   getSearch,
//   onSearchChange,
//   onSearchTagClose,
//   onDataUpdate,
//   postProductsSearch,
// } from '../slice';

const Header = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { userPermissions } = props;
  return (
    <Element>
      <_Header left={getI18n('salesChannelCategoryPages.index.pageCategory')} />
      {!userPermissions.canView && <NoPermission />}
    </Element>
  );
};
export default Header;
